module.exports = __webpack_public_path__ + "static/img/img_tsjb.9bc65bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img_tsjb.jpg
// module id = Ut3a
// module chunks = 1